import MainShaftAngularMisalignmentMutations from "./MainShaftAngularMisalignmentMutations";
import MainShaftAngularMisalignmentGetters from "./MainShaftAngularMisalignmentGetters";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import MainShaftAngularMisalignmentActions from "./MainShaftAngularMisalignmentActions";

const { getters } = MainShaftAngularMisalignmentGetters;

const state = {
	status:             FetchStatus.Init,
	successMessage:     "",
	errorMessage:       "",
	operatingRange:     0,
	signalSettingIds:   [],
	frequencyChartData: [],
	orderChartData:     [],
	orderLayout:        {},
	frequencyLayout:    {},
};

const { actions } = MainShaftAngularMisalignmentActions;

const { mutations } = MainShaftAngularMisalignmentMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	getters,
	namespaced,
};
